import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import './estilos.css';
import { ProveedorSesion, useSesion } from './contexto/Sesion.js';
import { iniciarWorkerOutbox } from './almacen/outbox.js';

// PWA: el SW precachea el shell de la app (nunca /api/*, eso es de Dexie).
if ('serviceWorker' in navigator) {
  registerSW({
    immediate: true,
    onRegisteredSW(_url, registro) {
      // El médico tiene la app abierta todo el día: chequear updates cada hora.
      if (registro) setInterval(() => void registro.update().catch(() => {}), 60 * 60 * 1000);
    },
  });
}
import { Landing } from './Landing.js';
import { Acceso } from './Acceso.js';
import { MedicoApp } from './medico/MedicoApp.js';
import { LoginMedico } from './medico/Login.js';
import { PortalApp } from './portal/PortalApp.js';
import { LoginPortal } from './portal/LoginPortal.js';
import { OperadorApp } from './operador/OperadorApp.js';
import { LoginOperador } from './operador/LoginOperador.js';
import { Descarga } from './publico/Descarga.js';

function Raiz() {
  useEffect(() => {
    // Pedir almacenamiento persistente: reduce el riesgo de que el navegador
    // desaloje IndexedDB (la cola outbox) bajo presión de disco.
    void navigator.storage?.persist?.().catch(() => {});
    return iniciarWorkerOutbox();
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/acceso" element={<Acceso />} />
      <Route path="/login" element={<LoginMedico />} />
      <Route path="/portal/login" element={<LoginPortal />} />
      <Route path="/operador/login" element={<LoginOperador />} />
      <Route path="/medico/*" element={<RequiereMedico><MedicoApp /></RequiereMedico>} />
      <Route path="/portal/*" element={<RequierePortal><PortalApp /></RequierePortal>} />
      <Route path="/operador/*" element={<RequiereOperador><OperadorApp /></RequiereOperador>} />
      <Route path="/descarga/:token" element={<Descarga />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequiereMedico({ children }: { children: JSX.Element }) {
  const { medico, cargando } = useSesion();
  const loc = useLocation();
  if (cargando) return <div className="cargando">Cargando…</div>;
  if (!medico) return <Navigate to="/login" replace state={{ desde: loc.pathname }} />;
  return children;
}

function RequierePortal({ children }: { children: JSX.Element }) {
  const { portal, cargando } = useSesion();
  if (cargando) return <div className="cargando">Cargando…</div>;
  if (!portal) return <Navigate to="/portal/login" replace />;
  return children;
}

function RequiereOperador({ children }: { children: JSX.Element }) {
  const { operador, cargando } = useSesion();
  if (cargando) return <div className="cargando">Cargando…</div>;
  if (!operador) return <Navigate to="/operador/login" replace />;
  return children;
}

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <BrowserRouter>
      <ProveedorSesion>
        <Raiz />
      </ProveedorSesion>
    </BrowserRouter>
  </StrictMode>,
);
